import { ApsDataClient, ApsFolderContent, ApsHub, ApsProject } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useQuery } from "@tanstack/react-query";

const apsDataClient = new ApsDataClient(undefined, axios);

export const useHubs = (options?: any) => {
  return useQuery<ApsHub[]>({
    ...options,
    queryKey: ["apsHubs"],
    queryFn: async () => await apsDataClient.getHubs(),
    placeholderData: [],
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 60 minutes    
  });
};

export const useGetProjects = (projectId: string, options?: any) => {
  return useQuery<ApsProject[]>({
    ...options,
    queryKey: ["apsProjects", projectId],
    queryFn: async () => apsDataClient.getProjects(projectId),
    placeholderData: [],
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 60 minutes    
  });
};

export const useGetItemVersions = (projectId: string, itemId: string, options?: any) => {
  return useQuery<ApsFolderContent[]>({
    ...options,
    queryKey: ["apsItemVersions", projectId, itemId],
    queryFn: async () => apsDataClient.getItemVersions(projectId, itemId),
    placeholderData: [],
    staleTime: 30 * 60 * 1000, // 30 minutes
    cacheTime: 60 * 60 * 1000, // 60 minutes    
  });
};
